module.exports = __webpack_public_path__ + "static/img/2.2897254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newSix/2.png
// module id = uMly
// module chunks = 0